let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5nQIT")).then(() => parcelRequire('6Ft10'));